import { post } from '../../../services/request';

import { get } from '../../../services/request';

export const fetchHoldCos = data => post('HoldingCompany/GetHoldingCompanyList', data);

// For get by id (edit)
export const fetchHoldCoById = id => get(`HoldingCompany/GetHoldingCompanyById?HoldingCompanyID=${id}`);

// For delete
export const deleteHoldCo = id => post(`HoldingCompany/DeleteHoldingCompany?HoldingCompanyID=${id}`);

// For delete file
export const deleteHoldCoFile = fileMappingId => post(`HoldingCompany/DeleteHoldingCompanyFileById?fileMappingId=${fileMappingId}`);

// For save
export const saveHoldingCompany = data => post('HoldingCompany/SaveHoldingCompany', data);